module.exports = __webpack_public_path__ + "img/20191107162018360截图20191107151449275.82a65435.jpg";